import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "sqg-formTemplate" }
const _hoisted_2 = {
  key: 0,
  class: "sqg-formTemplate__title"
}
const _hoisted_3 = {
  key: 1,
  class: "sqg-formTemplate__inputs"
}
const _hoisted_4 = {
  key: 0,
  class: "sqg-formTemplate__readOnly"
}
const _hoisted_5 = {
  key: 0,
  class: "sqg-formTemplate__checkbox"
}
const _hoisted_6 = { class: "sqg-formTemplate__checkboxTitle" }
const _hoisted_7 = {
  key: 1,
  class: "sqg-formTemplate__radio"
}
const _hoisted_8 = { class: "sqg-formTemplate__radioTitle" }
const _hoisted_9 = {
  key: 2,
  class: "sqg-formTemplate__select"
}
const _hoisted_10 = { class: "sqg-formTemplate__fileUploader" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Télécharger un fichier")
const _hoisted_12 = { class: "sqg-formTemplate__files" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Radio = _resolveComponent("Radio")!
  const _component_Select = _resolveComponent("Select")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_UploadFile = _resolveComponent("UploadFile")!
  const _component_Input = _resolveComponent("Input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    (_ctx.inputs.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputs, (input, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (_ctx.readOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createTextVNode(_toDisplayString(input.placeholder) + " : ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.computedValue(input.value)), 1)
                  ]))
                : (_ctx.checkCondition(input))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (input.type === 'checkbox')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(input.placeholder), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(input.choices, (choice, cIndex) => {
                              return (_openBlock(), _createBlock(_component_Checkbox, {
                                key: 'checkbox'+cIndex,
                                label: choice.name,
                                id: input.field + '-' + choice.name,
                                onChange: ($event: any) => (_ctx.updateCheckbox($event, input.choices, input.value))
                              }, null, 8, ["label", "id", "onChange"]))
                            }), 128))
                          ]))
                        : (input.type === 'radio')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, _toDisplayString(input.placeholder), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(input.choices, (choice, cIndex) => {
                                return (_openBlock(), _createBlock(_component_Radio, {
                                  key: cIndex,
                                  name: input.field + _ctx.title + index,
                                  label: choice.name,
                                  value: choice.id,
                                  checked: choice.id === input.value,
                                  onChange: ($event: any) => (input.value = choice.id)
                                }, null, 8, ["name", "label", "value", "checked", "onChange"]))
                              }), 128))
                            ]))
                          : (input.type === 'select')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(_component_Select, {
                                  placeholder: input.placeholder,
                                  choices: input.choices,
                                  choiceSelected: input.value,
                                  helperMsg: input.helper,
                                  required: input.required,
                                  onChange: ($event: any) => (input.value = $event),
                                  "onUpdate:error": _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateError(_ctx.errorCount, $event)))
                                }, null, 8, ["placeholder", "choices", "choiceSelected", "helperMsg", "required", "onChange"])
                              ]))
                            : (input.type === 'textarea')
                              ? (_openBlock(), _createBlock(_component_TextArea, {
                                  key: 3,
                                  placeholder: input.placeholder,
                                  value: input.value,
                                  "onUpdate:modelValue": ($event: any) => (input.value = $event),
                                  rules: input.rules,
                                  "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateError($event)))
                                }, null, 8, ["placeholder", "value", "onUpdate:modelValue", "rules"]))
                              : (input.type === 'uploadFile')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                    _createElementVNode("div", _hoisted_10, [
                                      _createElementVNode("div", null, _toDisplayString(input.placeholder), 1),
                                      _createVNode(_component_Button, {
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openUploadfile = true))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_11
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(input.value, (file, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "sqg-formTemplate__file",
                                          key: index
                                        }, [
                                          _hoisted_13,
                                          _createTextVNode(_toDisplayString(file), 1)
                                        ]))
                                      }), 128))
                                    ]),
                                    (_ctx.openUploadfile)
                                      ? (_openBlock(), _createBlock(_component_UploadFile, {
                                          folderIds: [_ctx.currentFolder.id],
                                          formId: _ctx.formId,
                                          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openUploadfile = false)),
                                          key: index,
                                          onUploadFile: ($event: any) => (_ctx.uploadFileSuccess(input, $event))
                                        }, null, 8, ["folderIds", "formId", "onUploadFile"]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createBlock(_component_Input, {
                                    key: 5,
                                    modelValue: input.value,
                                    "onUpdate:modelValue": ($event: any) => ((input.value) = $event),
                                    value: input.value,
                                    type: input.type,
                                    helperMsg: input.helper,
                                    placeholder: input.placeholder,
                                    rules: input.rules,
                                    "onUpdate:error": _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateError($event)))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "value", "type", "helperMsg", "placeholder", "rules"]))
                    ], 64))
                  : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", { errorCount: _ctx.errorCount })
  ]))
}